import React from 'react';
import { useTranslation } from 'react-i18next';
import { CFormSelect } from '@coreui/react';

const LanguageSwitcher = ({ size = "sm", className, style }) => {
  const { i18n } = useTranslation();

  const handleChangeLanguage = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  const currentLang = i18n.language ? i18n.language.split('-')[0] : 'en';

  return (
    <CFormSelect
      size={size}
      value={currentLang}
      onChange={handleChangeLanguage}
      style={{ width: 'auto', display: 'inline-block', ...style }}
      className={className}
      aria-label="Select language"
    >
      <option value="ru">🇷🇺 RU</option>
      <option value="kk">🇰🇿 KK</option>
      <option value="en">🇺🇸 EN</option>
    </CFormSelect>
  );
};

export default LanguageSwitcher;